import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

@Component({
	selector: 'shared-message-list',
	templateUrl: './message-list.component.html',
	styleUrl: './message-list.component.less',
	standalone: true,
	imports: [MatCardModule, MatIconModule, NgFor, NgIf, NgClass],
})
export class MessageListComponent {
	@Input() messages: MessageListModel[] = [];
	@Input() appearance = 'outlined';
	@Input() cardMaxHeight = '300px';

	public getMessageType(messageType: string): string {
		messageType = messageType?.toLowerCase();
		switch (messageType) {
			case 'error':
			case 'warning':
				return messageType;
			default:
				return 'info';
		}
	}
}

export interface MessageListModel {
	MessageType?: string; // error | warning | info
	Message?: string;
}
